import { useRef, useState } from 'react';
import { SIGNUP_STEPS } from '../../../types/enum';
import { ReactComponent as LoadingSvg } from '../../../assets/svg/loading-half-status.svg';
import { ReactComponent as ValidationCheckSvg } from '../../../assets/svg/validation-check.svg';
import request from '../../../lib/request';
import EmailVerification from './emailVerification';

const Email = ({ email, setEmail, setCurrentStep }) => {
  const emailRef = useRef(null);
  const verificationRef = useRef(null);

  const [emailError, setEmailError] = useState(false);
  const [emailExistError, setEmailExistError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [verificationCode, setVerificationCode] = useState('');
  const [sendCodeLoading, setSendCodeLoading] = useState(false);
  const [verificationCodeSent, setVerificationCodeSent] = useState(false);
  const [codeVerified, setCodeVerified] = useState(false);

  const checkEmail = async (address) => {
    try {
      setLoading(true);
      setCodeVerified(false);
      setVerificationCode('');
      setVerificationCodeSent(false);
      setSendCodeLoading(false);
      const { result } = await request.get(
        `/signup/check/duplication?email=${address}`
      );
      if (result) {
        setEmailExistError(false);
      }
      if (!result) {
        setEmailExistError(true);
      }
    } catch (err) {
      console.log(err);
      setEmailExistError(true);
    }
    setLoading(false);
  };

  const handleInput = (e) => {
    const value = String(e.target.value);

    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (emailRegex.test(value)) {
      setEmailError(false);
    }
    if (!emailRegex.test(value)) {
      setEmailError(true);
    }
    setEmail(value);

    if (value) {
      clearTimeout(emailRef.current);
      emailRef.current = setTimeout(async () => {
        if (!emailError) {
          await checkEmail(value);
        }
      }, 800);
    }
  };

  const handleInputVerificationCode = (e) => {
    const value = String(e.target.value.trim());
    setVerificationCode(value);

    if (value.length === 6) {
      clearTimeout(verificationRef.current);
      verificationRef.current = setTimeout(
        async () => await verifyCode(value),
        1500
      );
    }
  };

  const sendVerificationCode = async () => {
    try {
      setSendCodeLoading(true);
      const { result } = await request.get(
        `/email/verification-code?email=${email}`
      );
      if (result) {
        setVerificationCodeSent(true);
      }
    } catch (err) {
      console.log(err);
    }
    setSendCodeLoading(false);
  };

  const verifyCode = async (code) => {
    try {
      setLoading(true);
      const { result } = await request.post('/email/verification-code', {
        email,
        code,
      });
      if (result) {
        setCodeVerified(result);
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  const handleNext = () => {
    try {
      setCurrentStep(SIGNUP_STEPS.PASSWORD);
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div>
      <h1 className='font-bold mb-3 text-white text-4xl'>
        What's your Email(ID)?
      </h1>
      <div className='mb-5'>
        <div className='w-full bg-white rounded-full py-2 px-4 flex items-center justify-between'>
          <input
            type='email'
            className='w-full border-none '
            placeholder='Enter your email'
            value={email}
            onChange={handleInput}
          />
          {loading && (
            <LoadingSvg
              className='animate-spin opacity-15'
              width={16}
              height={16}
            />
          )}
          {codeVerified && (
            <div className='text-green-600 w-3 h-3'>
              <ValidationCheckSvg
                width={12}
                height={12}
              />
            </div>
          )}
        </div>
        {emailError && (
          <p className='text-red-600 text-xs mt-2'>
            Email must be a valid email address
          </p>
        )}
        {emailExistError && (
          <p className='text-red-600 text-xs mt-2'>Email already exists</p>
        )}
        {!codeVerified && (
          <EmailVerification
            verificationCode={verificationCode}
            sendVerificationCode={sendVerificationCode}
            handleInputVerificationCode={handleInputVerificationCode}
            verificationCodeSent={verificationCodeSent}
            sendCodeLoading={sendCodeLoading}
          />
        )}
      </div>
      <button
        className={`w-full bg-yellow-500 text-black font-bold rounded-full hover:bg-yellow-600 transition-colors duration-200 py-3 ${
          !email || emailError || loading || emailExistError || !codeVerified
            ? 'opacity-40'
            : 'hover:bg-yellow-600 transition-colors duration-200'
        }`}
        onClick={handleNext}
        disabled={
          !email || emailError || loading || emailExistError || !codeVerified
        }
      >
        Next
      </button>
    </div>
  );
};

export default Email;
